import { fetcher } from '#lib/backendFetcher';
import { validateResponse } from '#lib/validation';

import { userProfileSchema } from './userProfileSchemas';

/**
 * Fetches the profile of the currently logged-in user.
 * @returns {Promise<{data: Object|null, error: Error|null}>} The validated user profile or an error
 */
export const getUserProfile = async () => {
	try {
		const data = await fetcher('/api/v1/platform/users/me');
		if (data) validateResponse(userProfileSchema, data, 'userProfile');
		return { data, error: null };
	} catch (err) {
		return { data: null, error: err };
	}
};

/**
 * Updates the profile of the currently logged-in user.
 * @param {string} userId - The user ID (currently not used in the path)
 * @param {Object} updates - The profile fields to update
 * @returns {Promise<{data: Object|null, error: Error|null}>} The updated profile or an error
 */
export const updateUserProfile = async (userId, updates) => {
	try {
		const data = await fetcher('/api/v1/platform/users/me', {
			method: 'PATCH',
			body: updates,
		});
		return { data, error: null };
	} catch (err) {
		return { data: null, error: err };
	}
};
